import Image from 'next/image';
import type { ArbitraryTypedObject } from '@portabletext/types';
import { PortableTextBlock } from '@sanity/types';
import { getSanityImageUrl } from '@/libs/sanity/client';
import laptopImg from '../images/video-laptop.webp';
import { Suspense } from 'react';
import { PortableTextWrapper } from '@/components/PortableTextWrapper';
import MediaModal from '@/components/ui/media-modal';
import { useMediaQuery } from 'usehooks-ts';
import { MOBILE_SCREEN_SIZE } from '@/utils/constants';

type LeftTextRightImageProps = {
  anchor?: string;
  content:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
  video?: any;
  image?: any;
};

const TopContentMediaBottom = ({
  anchor,
  content,
  video,
}: LeftTextRightImageProps) => {
  const isMobile = useMediaQuery(`(max-width: ${MOBILE_SCREEN_SIZE}px)`);
  return (
    <section
      id={anchor}
      className="max-w-8xl mx-auto gap-x-8 mt-8 scroll-mt-[150px]"
    >
      <div className="w-full">
        {content && <PortableTextWrapper value={content} />}
      </div>
      {video && (
        <>
          {!isMobile ? (
            <div className="mt-10 relative w-full">
              <Image
                src={getSanityImageUrl(video.coverImage)}
                alt="Image"
                className="object-cover w-full h-auto"
                loading="lazy"
                height={550}
                width={1440}
              />
              <p className="text-sm mt-1 font-semibold">{video.title}</p>
              <Image
                className="absolute top-[80px] right-[20px] z-10 w-[333px] h-auto"
                src={laptopImg}
                alt="laptop"
                width={384}
                height={217}
              />
              {video && (
                <div className="absolute top-[89px] right-[60px] z-20 w-[255px] h-[155px]">
                  <Suspense fallback={<p>Loading video...</p>}>
                    <MediaModal
                      className="h-[155px] object-cover"
                      videoSrc={video.videoUrl}
                    ></MediaModal>
                  </Suspense>
                </div>
              )}
            </div>
          ) : (
            <div className="mt-2 mb-4 w-full">
              <Suspense fallback={<p>Loading video...</p>}>
                <video className="w-full object-cover" muted autoPlay loop>
                  <source src={video.videoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </Suspense>
            </div>
          )}
        </>
      )}
    </section>
  );
};
export default TopContentMediaBottom;
